// extracted by mini-css-extract-plugin
export default {"HeaderTitle":"ThemeTestComponent_HeaderTitle__QCPD4","Wrapper":"ThemeTestComponent_Wrapper__3-C0U","buttonWrapper":"ThemeTestComponent_buttonWrapper__+dzqU"};